import { render, staticRenderFns } from "./MdPatientDiagCodes.vue?vue&type=template&id=60b82568&"
import script from "./MdPatientDiagCodes.vue?vue&type=script&lang=js&"
export * from "./MdPatientDiagCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports